import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { ShieldAlert, LogOut } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../lib/auth.jsx";
import { ChangePasswordForm } from "../components/ChangePasswordForm.jsx";

export default function ForceChangePasswordPage() {
  const { user, setUser, logout } = useAuth();
  const navigate = useNavigate();

  if (user === undefined) return <div className="h-screen flex items-center justify-center text-sm text-[#6C757D]">A carregar…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.must_change_password) return <Navigate to="/" replace />;

  const onSuccess = (fresh) => {
    setUser(fresh);
    toast.success("Palavra-passe alterada com sucesso");
    navigate("/", { replace: true });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-ronil-light px-6 py-12" data-testid="force-change-password-page">
      <div className="relative w-full max-w-md bg-white border border-slate-200 rounded-lg shadow-elevation p-8 sm:p-10">
        <div className="text-[10px] uppercase tracking-[0.25em] text-ronil-sand font-heading font-bold mb-2 flex items-center gap-2">
          <ShieldAlert className="w-3 h-3" /> Segurança da conta
        </div>
        <h1 className="font-display text-3xl font-bold text-ronil-navy tracking-tight mb-2 leading-tight">Altere a sua palavra-passe</h1>
        <p className="text-sm text-slate-500 leading-relaxed mb-6">
          Olá <b>{user.name}</b>. Por segurança, deve definir uma palavra-passe pessoal antes de continuar a usar o Ronil Command Center.
        </p>
        <ChangePasswordForm onSuccess={onSuccess} submitLabel="Guardar e continuar" />
        <button
          type="button"
          data-testid="force-change-password-logout"
          onClick={logout}
          className="mt-6 inline-flex items-center gap-1.5 text-xs text-ronil-navy hover:underline font-medium"
        >
          <LogOut className="w-3 h-3" /> Terminar sessão
        </button>
      </div>
    </div>
  );
}
